module.exports = __webpack_public_path__ + "img/ang5.8a6dcd21.png";